import { Pipe, PipeTransform } from '@angular/core';
import { Address, JobUtility } from '@jms/model';

@Pipe({
  name: 'address',
  standalone: true
})
export class AddressPipe implements PipeTransform {

  transform(address: Address, excludeStreet = false, includeName = false): string {

    if (excludeStreet) {
      const address2 = JobUtility.getAddress2(address);
      return !address2 || address2 === '' ? 'Not Set' : address2;
    }

    var fullAddress = JobUtility.address(address);

    if (includeName && address?.name) {
      fullAddress = `${address.name} - ${fullAddress}`;
    }

    return !fullAddress || fullAddress === '' ? 'Not Set' : fullAddress;
  }

}
